import { createToaster } from '@significa/svelte-toaster';

export type ToastData = {
  title: string;
  description?: string;
  type?: 'loading' | 'success' | 'error';
  action?: {
    label: string;
    handler: () => void;
  };
};

export const toaster = createToaster<ToastData>({
  duration: ({ data }) => (data.type === 'error' ? 5000 : 2000)
});
